import { cn } from '@/app/utils/cn';
import { IconCircleArrowUpRight } from '@tabler/icons-react';
import Image from 'next/image';
import LinkNoPrefetch from '@/components/link-noprefetch';

export const ImportantThings = ({ featureRelationship }) => {
    if (!featureRelationship || featureRelationship.length === 0) return null;

    const baseClass = 'flex flex-col justify-between rounded-2xl h-full border';
    const levelStyles = {
        0: cn(
            `md:min-h-[32.5rem] border-blue bg-[url('/assets/home/home-important-bg.svg')] bg-no-repeat bg-contain bg-right text-green gap-28 md:gap-0`
        ),
        1: cn('border-green bg-green-200 text-green'),
        2: cn('border-cyan bg-cyan-200 text-cyan')
    };
    const iconStyles = {
        0: 'w-[7.5rem] h-[7.5rem] mt-10 md:ml-6 lg:mt-[3.25rem] lg:ml-[3.25rem] lg:w-40 lg:h-40'
    };
    const defaultIconStyle = 'w-[5.5rem] h-[5.5rem] mt-6 ml-6 lg:ml-[3.25rem] lg:mt-8 mb-4';

    return (
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2 md:grid-rows-2">
            {featureRelationship.slice(0, 3).map((feature, index) => {
                const isFirstItem = index === 0;
                const cssClasses = cn(isFirstItem && 'row-span-1 md:row-span-2');

                return (
                    <div key={index} className={cssClasses}>
                        <ImportantThing
                            feature={feature}
                            iconStyle={iconStyles[index] ?? defaultIconStyle}
                            className={`${baseClass} ${levelStyles[index]}`}
                        />
                    </div>
                );
            })}
        </div>
    );
};

const ImportantThing = ({ feature, className, iconStyle }) => {
    const { callToAction = [] } = feature;
    const { url } = callToAction[0] ?? {};

    if (url) {
        return (
            <LinkNoPrefetch href={url} className={className}>
                <ImportantThingCard {...feature} url={url} iconStyle={iconStyle} />
            </LinkNoPrefetch>
        );
    }

    return (
        <div className={className}>
            <ImportantThingCard {...feature} url={url} iconStyle={iconStyle} />
        </div>
    );
};

const ImportantThingCard = ({ url, iconStyle, icon, label, headline }) => {
    return (
        <>
            <div className="flex items-start justify-between">
                {icon && (
                    <div className={iconStyle}>
                        <Image
                            src={icon}
                            width={0}
                            height={0}
                            quality={80}
                            sizes="120px"
                            className="h-auto w-full"
                            alt={`${label} option`}
                        />
                    </div>
                )}
                {url && (
                    <div className={`mx-6 my-4 font-semibold`}>
                        Learn more&nbsp;
                        <IconCircleArrowUpRight className="inline-block size-12 stroke-1 lg:size-14" />
                    </div>
                )}
            </div>
            <div className="m-4 flex flex-col justify-end md:mb-6 md:ml-6 lg:m-0 lg:mb-[3.25rem] lg:ml-[3.25rem]">
                {label && <h4 className="text-slate-600">{label}</h4>}
                {headline && <p className="mt-3">{headline}</p>}
            </div>
        </>
    );
};
